export interface Configuration {
  _id: string;
  category: string;
  key: string;
  value: any;
  label: string;
  description: string;
  isActive: boolean;
  sortOrder: number;
  metadata: Record<string, any>;
  createdBy: {
    _id: string;
    username: string;
    email: string;
  };
  updatedBy?: {
    _id: string;
    username: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ConfigurationCategory {
  [category: string]: Configuration[];
}

export interface CreateConfigurationRequest {
  category: string;
  key: string;
  value: any;
  label: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  metadata?: Record<string, any>;
}

export interface UpdateConfigurationRequest {
  value?: any;
  label?: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  metadata?: Record<string, any>;
}

export interface BulkCreateConfigurationRequest {
  configurations: CreateConfigurationRequest[];
}

export interface ConfigurationResponse {
  success: boolean;
  data?: Configuration | Configuration[] | ConfigurationCategory;
  message?: string;
  error?: string;
}

export const CONFIGURATION_CATEGORIES = [
  'user_roles',
  'user_permissions',
  'notification_types',
  'gender_options',
  'status_options',
  'priority_levels',
  'department_types',
  'specialization_types',
  'insurance_types',
  'verification_status',
  'order_status',
  'invoice_status',
  'demographics_categories',
  'product_categories',
  'system_settings',
  'ui_settings'
] as const;

export type ConfigurationCategoryType = typeof CONFIGURATION_CATEGORIES[number];
